import {
  ArchiveIcon_default
} from "./chunk-GDXFNH2V.mjs";
export {
  ArchiveIcon_default as default
};
